import Axios from "axios";
import {config} from "@/config";

Axios.defaults.baseURL = config.apiUrl;
Axios.defaults.headers.common['Content-Type'] = 'application/json';
export default {
    namespaced: true,
    modules: {
    },
    state: {
        items: [],
        pagination: {
            total: 0,
            limit: 20,
            currentPage: 1,
        }
    },
    mutations: {
        SET_ITEMS: (state, payload) => {
            return state.items = payload;
        },
        SET_PAGINATION: (state, payload) => {
            return state.pagination = payload;
        }
    },
    actions: {
        GET_LIST: ({dispatch, commit}, params) => {
            let url = '/bulk-delete';
            const queryParams = [];
            Object.keys(params).map((key,index) => {
                if(params[key] !== ''){
                    queryParams.push(`${key}=${encodeURIComponent(params[key])}`)
                }
            })
            const sQueryParams = queryParams.join('&')
            url = `${url}?${sQueryParams}`
            dispatch('SEND_GET', {
                url,
                getSuccessResponse: (responseData)=>{
                    commit('SET_ITEMS', responseData.content);
                    commit('SET_PAGINATION', {total: responseData.total, limit: responseData.limit, currentPage: params.page});
                },
                showSuccessMessage: false
            }, { root: true });
        },
        // eslint-disable-next-line no-unused-vars
        ADD_LIST: async ({dispatch, state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/bulk-delete',
                parameter: payload.data,
                th: payload.th,
                showSuccessMessage: true,
                getSuccessResponse: (responseData) => {
                    if (responseData == 7) console.log(responseData);
                    if (payload.handleSuccessResponse !== undefined) {
                        payload.handleSuccessResponse();
                    }
                    dispatch('GET_LIST', {
                        entity: 'products',
                        page: state.pagination.currentPage
                    });
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        DELETE_ITEM: ({dispatch, commit, state}, {id, th}) => {
            return dispatch('SEND_DELETE', {
                url: '/bulk-delete/' + id,
                getSuccessResponse: ()=>{
                    let items   = state.items.filter((item)=>{
                        return item.id !== id
                    })
                    commit('SET_ITEMS', items);
                },
                showSuccessMessage: true,
                th
            }, { root: true });
        },
        DELETE_PRODUCTS: async({dispatch, state}, payload) => {
            payload.th.showOverlay++;
            return dispatch('SEND_POST', {
                url: '/bulk-delete/run',
                parameter: payload.data,
                th: payload.th,
                showSuccessMessage: true,
                getSuccessResponse: (responseData) => {
                    if (responseData == 7) console.log(responseData);
                    if (payload.handleSuccessResponse !== undefined) {
                        payload.handleSuccessResponse();
                    }
                    dispatch('GET_LIST', {
                        entity: 'products',
                        page: state.pagination.currentPage
                    });
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            }, { root: true });
        }
    }
}